import { __extends, __makeTemplateObject, __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import { PvdBaseComponent } from '../pvd-base-component/pvd-base-component.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { svg as b, html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { Size } from '../pvd-utils/enums/size.js';
import IconNames from './enums/icon-names.js';

var SVG_PROTECTED_ATTR_MAP = new Map([
    ['aria-hidden', 'pvd-a11y-label'],
    ['aria-labelledby', 'pvd-a11y-label'],
    ['focusable', 'pvd-a11y-label'],
    ['role', 'pvd-a11y-label'],
]);
/**
 * Providence Icon component.
 * @see {@link https://providence.fmr.com/components/icon/icon.html|Icon documentation}
 */
var PvdIcon = /** @class */ (function (_super) {
    __extends(PvdIcon, _super);
    function PvdIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._pvdName = 'action__add';
        _this._pvdSize = Size.medium;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdIcon.prototype, "pvdName", {
        get: function () {
            return this._pvdName;
        },
        set: function (value) {
            var size = this.pvdSize;
            if (this.validateIconNameForSize(value, size)) {
                var oldVal = this._pvdName;
                this._pvdName = value;
                this.requestUpdate('pvdName', oldVal);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdIcon.prototype, "pvdSize", {
        get: function () {
            return this._pvdSize;
        },
        set: function (value) {
            var name = this.pvdName;
            if (this.validateIconNameForSize(name, value)) {
                var oldVal = this._pvdSize;
                this._pvdSize = value;
                this.requestUpdate('pvdSize', oldVal);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdIcon.prototype, "iconHref", {
        // #endregion
        // #region private methods
        get: function () {
            return "#".concat(this.constructor.namespace, "-").concat(this.pvdName);
        },
        enumerable: false,
        configurable: true
    });
    PvdIcon.prototype.validateIconNameForSize = function (name, size) {
        if (size === Size.extraSmall && IconNames.extraSmall.indexOf(name) === -1) {
            console.warn("You cannot use the '".concat(name, "' icon at the 'extra-small' size. Please choose a different icon or a larger size."));
        }
        return true;
    };
    /**
     * Generates a unique ID for the Icon's title
     */
    PvdIcon.prototype.generatedA11yLabelledbyId = function () {
        if (!this._generatedA11yLabelledbyId) {
            this._generatedA11yLabelledbyId = "pvd-icon-title-".concat(PvdBaseComponent.generateRandomNumber());
        }
        return this._generatedA11yLabelledbyId;
    };
    /**
     * Sets attributes on the svg element that are coming from pvdNativeSvgAttributes
     * @param prevAttr optional, if user updates pvdNativeSvgAttributes, this will remove/update existing attributes
     */
    PvdIcon.prototype.setNativeSvgAttributes = function (prevAttr) {
        var targetElement = this.querySelector('svg');
        this.setNativeAttributes(this.pvdNativeSvgAttributes, SVG_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    };
    // #endregion
    // #region LitElement lifecycles
    PvdIcon.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (this.pvdNativeSvgAttributes) {
            var prevAttr = changedProperties.get('pvdNativeSvgAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeSvgAttributes(prevAttr);
        }
    };
    PvdIcon.prototype.renderIconSvgTitle = function () {
        return b(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<title id=", ">", "</title>"], ["<title id=", ">", "</title>"])), this._generatedA11yLabelledbyId, this.pvdA11yLabel);
    };
    PvdIcon.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-icon-root"),
            modifierPrefix: 'pvd-icon',
            modifiers: [
                {
                    condition: this.pvdIconClass !== undefined,
                    className: this.pvdIconClass,
                    modifierPrefix: false,
                },
                {
                    condition: this.pvdSize !== Size.medium,
                    className: "".concat(this.pvdSize),
                },
            ],
        };
        return x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<svg\n      aria-hidden=", "\n      aria-labelledby=", "\n      class=\"", "\"\n      focusable=", "\n      role=", "\n    >\n      ", "\n      <use href=", " xlink:href=", " />\n    </svg>"], ["<svg\n      aria-hidden=", "\n      aria-labelledby=", "\n      class=\"", "\"\n      focusable=", "\n      role=", "\n    >\n      ", "\n      <use href=", " xlink:href=", " />\n    </svg>"])), this.pvdA11yLabel ? 'false' : 'true', l(this.pvdA11yLabel ? this.generatedA11yLabelledbyId() : undefined), getClassName(classMap), this.pvdA11yLabel ? 'true' : 'false', l(this.pvdA11yLabel ? 'img' : undefined), this.pvdA11yLabel ? this.renderIconSvgTitle() : A, this.iconHref, this.iconHref);
    };
    //#region Component configuration
    PvdIcon.componentName = 'icon';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-a11y-label' }),
        __metadata("design:type", String)
    ], PvdIcon.prototype, "pvdA11yLabel", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-class' }),
        __metadata("design:type", String)
    ], PvdIcon.prototype, "pvdIconClass", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-name' }),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], PvdIcon.prototype, "pvdName", null);
    __decorate([
        n({ type: Object, attribute: 'pvd-native-svg-attributes' }),
        __metadata("design:type", Object)
    ], PvdIcon.prototype, "pvdNativeSvgAttributes", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-size' }),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], PvdIcon.prototype, "pvdSize", null);
    return PvdIcon;
}(PvdBaseComponent));
var templateObject_1, templateObject_2;

export { PvdIcon, SVG_PROTECTED_ATTR_MAP };
